/* ACHILLES - collection grid view switcher (Mango-style "change of grid view")
   Three icon buttons next to Filter / Sort that set the product grid density:
     large   = 1-up mobile / 2-up desktop
     default = 2-up mobile / 4-up desktop
     compact = 3-up mobile / 6-up desktop
   The choice is remembered per visitor in localStorage.
   Pairs with achilles-grid-view.css. Bump CSS_VERSION after editing that file. */
(function () {
  'use strict';

  var CSS_VERSION = '3';
  var STORE_KEY = 'achilles_grid_view';

  var VIEWS = [
    { id: 'large',   cls: 'acgv-large',   label: 'Show few items' },
    { id: 'default', cls: '',             label: 'Show more items' },
    { id: 'compact', cls: 'acgv-compact', label: 'Show maximum items' }
  ];

  var me = document.currentScript && document.currentScript.src;
  if (me && !document.querySelector('link[href*="achilles-grid-view.css"]')) {
    var href = me.split('?')[0].replace('achilles-grid-view.js', 'achilles-grid-view.css');
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = href + '?v=' + CSS_VERSION;
    document.head.appendChild(l);
  }

  function valid(v) {
    for (var i = 0; i < VIEWS.length; i++) if (VIEWS[i].id === v) return v;
    return 'default';
  }
  function read() {
    try { return valid(localStorage.getItem(STORE_KEY)); } catch (e) { return 'default'; }
  }
  function write(v) {
    try { localStorage.setItem(STORE_KEY, v); } catch (e) {}
  }

  var state = read();

  // one square / four squares / nine squares - the density each button selects
  function icon(id) {
    if (id === 'large') {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="4" y="4" width="16" height="16"/></svg>';
    }
    if (id === 'default') {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="3" y="3" width="8" height="8"/><rect x="13" y="3" width="8" height="8"/><rect x="3" y="13" width="8" height="8"/><rect x="13" y="13" width="8" height="8"/></svg>';
    }
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="2" y="2" width="6" height="6"/><rect x="9" y="2" width="6" height="6"/><rect x="16" y="2" width="6" height="6"/><rect x="2" y="9" width="6" height="6"/><rect x="9" y="9" width="6" height="6"/><rect x="16" y="9" width="6" height="6"/><rect x="2" y="16" width="6" height="6"/><rect x="9" y="16" width="6" height="6"/><rect x="16" y="16" width="6" height="6"/></svg>';
  }

  function paint() {
    var grids = document.querySelectorAll('.collection-grid__wrapper .grid, .grid--uniform');
    for (var i = 0; i < grids.length; i++) {
      if (!grids[i].querySelector('.grid-product')) continue;
      for (var v = 0; v < VIEWS.length; v++) {
        if (VIEWS[v].cls) grids[i].classList.toggle(VIEWS[v].cls, VIEWS[v].id === state);
      }
    }
    var btns = document.querySelectorAll('.acgv-btn');
    for (var b = 0; b < btns.length; b++) {
      btns[b].setAttribute('aria-pressed', btns[b].dataset.view === state ? 'true' : 'false');
    }
  }

  function select(id) {
    state = valid(id);
    write(state);
    paint();
  }

  function inject() {
    var bars = document.querySelectorAll('.achilles-v2__trigger-buttons');
    for (var i = 0; i < bars.length; i++) {
      if (bars[i].querySelector('.acgv-group')) continue;
      var group = document.createElement('div');
      group.className = 'acgv-group';
      group.setAttribute('role', 'group');
      group.setAttribute('aria-label', 'Change of grid view');
      for (var v = 0; v < VIEWS.length; v++) {
        (function (view) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'acgv-btn';
          btn.dataset.view = view.id;
          btn.setAttribute('aria-label', view.label);
          btn.innerHTML = icon(view.id);
          btn.addEventListener('click', function (e) { e.preventDefault(); select(view.id); });
          group.appendChild(btn);
        })(VIEWS[v]);
      }
      bars[i].appendChild(group);
    }
    paint();
  }

  function start() {
    inject();
    // the filter bar and the product grid are both re-rendered (filters, infinite scroll),
    // so re-apply whenever the DOM changes
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; inject(); }, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();